// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"wrapper__3piT6","wrapper-nopadding":"wrapper-nopadding__1J4gi","loading":"loading__wMV7w","error":"error__1V7dW","table-loading":"table-loading__2g85M","empty-val":"empty-val__3qQuN","panelheader-tools":"panelheader-tools__3Np6_","propsPanels":"propsPanels__29dZE","new":"new__CQkAo","marginLm":"marginLm__2DdMt","marginRm":"marginRm__ApruV","fullWidth":"fullWidth__2noE6","fullHeight":"fullHeight__3cPUG","noData":"noData__3vcKx"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Application/coms/ApplicationDetail/coms/BroadcastView/coms/EditAddress/styles.scss
// module id = 2180
// module chunks = 1